import { takeAuthReturnTo } from '@utils/authReturnTo';
import type React from 'react';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { signInThunk } from '../../redux/auth/thunks';
import type { RootState } from '../../redux/reducers';
import { routePaths } from '../routes';

const AuthRedirect: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { signInStatus } = useSelector((state: RootState) => state.Auth);

  const navigatedRef = useRef(false);

  useEffect(() => {
    const code = searchParams.get('code') || '';
    dispatch(signInThunk(code));
  }, [dispatch, searchParams]);

  // Latched because takeAuthReturnTo() clears what it reads: a second pass would find nothing
  // left and fall through to the organizations list.
  useEffect(() => {
    if (navigatedRef.current) return;

    if (signInStatus === 'error') {
      navigatedRef.current = true;
      navigate(routePaths.signIn, { replace: true });
      return;
    }

    if (signInStatus !== 'success') return;

    // signInThunk writes the tokens to localStorage just before dispatching success.
    const tokens = JSON.parse(localStorage.getItem('tokens') ?? 'null');
    if (!tokens?.['access_token']) return;

    navigatedRef.current = true;
    // `replace` keeps this callback URL, which carries the one-time code, out of the history.
    navigate(takeAuthReturnTo() ?? routePaths.organizations, { replace: true });
  }, [signInStatus, navigate]);

  return null;
};

export default AuthRedirect;
